/** /channel-partner/hub/profile — CP profile, code and agreement. */
import { createFileRoute } from '@tanstack/react-router';
import { ChannelPartnerHubProfile } from '@/features/channel-partner/components/hub-profile';

export const Route = createFileRoute('/_protected/channel-partner/hub/profile')({
  component: ChannelPartnerHubProfile,
});
